//AWS and REACT Libraries 

import { Authenticator } from '@aws-amplify/ui-react';
import React, { useState } from 'react';

//page components
import NavMenu from '../section/LoggedInNav.js';
import SITELINKS from '../section/Footer.js';
import Banner from '../section/Title.js';
import MessagesData from '../section/MessagesData.js'//used to show the user when they are logged in how to use the website

//boostrap components 
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export const ProtectedPage = () => {
  // MessagesTable logic directly in this component:
  const initialMessages = [
    {
      id: 1,
      timestamp: '02/01/25 10:08 AM',
      text: 'Portal Updated with S8, MRVP, WSD, and HOMEBASE Payments as of 2/01/26',
      expanded: true,
      read: false,
    },    
    {
      id: 2,
      timestamp: '01/20/25 07:08 AM',
      text: 'We wanted to inform you of a potential delay in rental subsidy payments for the Section 8 and MRVP scheduled to be issued to you in early February. The Commonwealth of Massachusetts is transitioning to a new financial management system, which will require a one-week processing blackout period during which no transactions can be processed. As a result, payments from the Commonwealth of Massachusetts Executive Office of Housing and Livable Communities to Metro Housing and the Regional Administering Agencies (RAAs) may be delayed, and your subsidy payment(s) may be received a few days later than usual. \n EOHLC and the RAAs are prioritizing the timely release of all payments and apologize for any inconvenience this may cause, particularly following the recent voucher software transition. We greatly value your partnership in providing stable housing and appreciate your patience during this period of transition.  We remain fully committed to ensuring accurate and timely payments and to supporting you in the essential role you play in our housing programs.',
      expanded: true,
      read: false,
    },
    {
      id: 3,
      timestamp: '12/15/25 05:08 PM',
      text: 'Missing Remittance Details: \n We are actively working to resolve missing data and provide remittance details. Rest assured, we are handling these cases individually and will continue updating the Portal as additional payment data becomes available from the new system.',
      expanded: true,
      read: false,
    },
    {
      id: 4,
      timestamp: '11/15/25 12:08 PM',
      text: 'Missing Remittance Details: \n We are actively working to resolve missing data and provide remittance details. Rest assured, we are handling these cases individually and will continue updating the Portal as additional payment data becomes available from the new system.',
      expanded: false,
      read: false,
    },
    {
      id: 5,
      timestamp: '08/01/25 12:08 PM',
      text: 'Portal Update Completed: \nThe portal has been updated to version 2.1. New features include enhanced security measures and a more user-friendly interface.',
      expanded: false,
      read: false,
    },
    {
      id: 6,
      timestamp: '01/26/25 11:57 AM',
      text: 'System Outage Notice: \nWe are currently experiencing a system outage. Our team is working to resolve the issue as quickly as possible.',
      expanded: false,
      read: false,
    },

  ];
  const [messages, setMessages] = useState(initialMessages);

  const toggleRead = (id) => {
    setMessages(messages.map(msg =>
      msg.id === id ? { ...msg, read: true } : msg
    ));
  };

  const toggleExpand = (id) => {
    setMessages(messages.map(msg =>
      msg.id === id ? { ...msg, expanded: !msg.expanded } : msg
    ));
  };

  return (

    <div className='App'>
      <div className='hidden'>
        <Banner/>
      </div>
      <NavMenu/> 
      
      <Authenticator className='login_container container' loginMechanisms={['email']} hideSignUp>

        <Container>
            <Row>
              <Col  xs={12} md={12} lg={12} xl={12}>
                  <MessagesData/>
              </Col>
              <Col  xs={12} md={12} lg={12} xl={12}>
              
              <div className="messages-container">
                <h2 className='emphTitle'>Messages ({messages.length})</h2>
                {messages.map(msg => (
                  <div key={msg.id} className={`message ${msg.read ? 'read' : ''}`}>
                    <div className="m_header">
                      <span className="timestamp">{msg.timestamp}</span>
                      <button className='message_button hide' onClick={() => toggleRead(msg.id)}>Mark as Read</button>
                    </div>
                    <p>{msg.expanded ? msg.text : msg.text.split('\n')[0]}</p>
                    {msg.text.includes('\n') && (
                      <button className='message_button' onClick={() => toggleExpand(msg.id)}>
                        {msg.expanded ? 'CLOSE MESSAGE' : 'OPEN MESSAGE'}
                      </button> 
                    )} 
                  </div>
                ))}
              </div>

              </Col>

            </Row>

          </Container>
      </Authenticator>       

      <SITELINKS/> 
    
    </div>
  );
};